module.exports = {
    API_BASE_URL: 'https://7e8b-206-42-123-162.ngrok-free.app',
    BasicToken: '',
};


